import validate from '../../../services/reduxValidate.js';
import conf from '../../../../shared/conf.js';

export default function (data) {
  const options = {
    mainUniverse: {
      presence: {
        message: 'Vous devez choisir un univers pour pouvoir vous inscrire'
      }
    },
    tel: {
      format: {
        pattern: /^\+?([0-9.\-\s]+)$/g,
        message: "Le numéro de téléphone est invalide (format souhaité : +33612345678)"
      }
    },
    cgu_accepted: {
      presence: {
        message: 'Vous devez accepter les CGU pour pouvoir vous inscrire'
      },
      inclusion: {
        within: [true],
        message: 'Vous devez accepter les CGU pour pouvoir vous inscrire'
      }
    },
  };

  if (data.account_type !== conf.accountTypes.do) {
    options.tel.presence = true;
  }

  return validate(data, options);
}